import React from 'react';
import { SectionHeading } from '../ui/section-heading';
import { useScrollReveal } from '../../hooks/useScrollReveal';

const steps = [
  { letter: 'T', name: 'Top 3 Use-Cases', description: 'Identify the 3 highest-impact, repeatable jobs AI should handle in your business.' },
  { letter: 'R', name: 'Rules for Inputs', description: 'Define brand voice, examples, and constraints so AI produces usable output every time.' },
  { letter: 'U', name: 'Unlock AI Skills', description: 'Teach your AI once, it executes reliably every time. We help you build the right skills.' },
  { letter: 'S', name: 'Sanity-Check Output', description: 'A simple QA checklist so you trust AI results without rewriting them.' },
  { letter: 'T', name: 'Tie & Automate', description: 'Connect prompts, tools, and steps into flows that run reliably.' },
];

const TrustLoopSection: React.FC = () => {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <div className="relative overflow-hidden" style={{ background: 'linear-gradient(160deg, #07000d 0%, #0f0118 40%, #0a000f 100%)' }}>
      {/* Giant TRUST silhouette */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none" aria-hidden="true">
        <span
          className="text-[20rem] md:text-[28rem] lg:text-[36rem] font-black tracking-[-0.04em] leading-none text-transparent"
          style={{
            WebkitTextStroke: '1px rgba(127, 3, 161, 0.06)',
            background: 'linear-gradient(180deg, rgba(127,3,161,0.04) 0%, rgba(127,3,161,0.02) 100%)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
          }}
        >
          TRUST
        </span>
      </div>

      <div
        ref={ref}
        className={`relative z-10 py-28 md:py-36 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
      >
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <SectionHeading
            label="Signature Method"
            title="The TRUST Loop"
            description="A repeatable framework that turns AI chaos into confident, automated execution."
            variant="dark"
          />

          {/* Connected cards — stacked on mobile, row on desktop */}
          <div className="border border-white/[0.08] rounded-2xl overflow-hidden flex flex-col lg:flex-row">
            {steps.map((step, i) => (
              <div
                key={i}
                className={`p-6 lg:p-7 lg:flex-1 ${
                  i < steps.length - 1 ? 'border-b lg:border-b-0 lg:border-r border-white/[0.08]' : ''
                }`}
              >
                <span className="text-white/20 text-2xl font-bold uppercase tracking-widest mb-3 block">
                  {step.letter}
                </span>
                <h3 className="text-white font-bold text-base mb-2">{step.name}</h3>
                <p className="text-white/35 text-sm leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  );
};

export default TrustLoopSection;
